import { DataTableActions } from 'src/components/DataTable';
import { useParams } from 'react-router-dom';
import { useStoreUnitActions } from 'src/redux/helpers';
import { isModalComplete } from 'src/components/ModalDialog';
import { useModal } from 'src/hooks';
import { useSolutionUserRoles } from '../../hooks';
import solutionsStore from '../../redux';
import SolutionDashboardDeleteModal from './SolutionDashboardDeleteModal';

type Props = {
  item?: any;
  onView?: (item: any) => void;
};

function SolutionDashboardActions({ item, onView }: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { solutionId } = useParams();
  const { isSolutionEditor } = useSolutionUserRoles(solutionId);
  const onClose = (event, reason) => isModalComplete(reason);

  const handleView = () => {
    if (onView) {
      onView(item);
      actions.WidgetList({
        solutionId,
        dashboardId: item?.id,
        twinId: item?.twinId,
      });
    }
  };

  const [DeleteDialog, handleDelete] = useModal(SolutionDashboardDeleteModal, {
    item,
    onClose,
  });

  return (
    <DataTableActions
      showView={true}
      showEdit={false}
      showDelete={true}
      onView={handleView}
      onDelete={handleDelete}
      canDelete={isSolutionEditor}
    >
      {DeleteDialog}
    </DataTableActions>
  );
}

export default SolutionDashboardActions;
